import React from 'react'

import { MinimalButton } from '@bikemap/components'
import { gettext } from '@bikemap/js/services'

const t = {
    CLOSE: gettext('Close'),
    FILTERS: gettext('Filters'),
}

/**
 * Button that toggles the search filters view and indicates when custom filters are set.
 * @param {Object} props
 * @param {boolean} [props.filtersShown] If filters are currently open
 * @param {(showFilters: boolean) => void} props.onClick
 * @param {boolean} [props.hasCustomFilter] If a filter was set by the user
 * @param {string} [props.className]
 */
const FiltersButton = ({
    filtersShown, onClick, hasCustomFilter, className,
}) => filtersShown ? (
    <MinimalButton className={className} variant="primary" icon="i-close"
        onClick={e => onClick(false)} align>
        {t.CLOSE}
    </MinimalButton>
) : (
    <MinimalButton className={className} variant={hasCustomFilter ? 'primary' : null}
        icon="i-filter" onClick={e => onClick(true)} align>
        {t.FILTERS}
    </MinimalButton>
)

export default FiltersButton
